import React, { useRef } from 'react';
import { Image, ImageProps } from '@/components/common/image';

type FallbackImageProps = Omit<ImageProps, 'src'> & {
  /** 优先加载的图片（如 resize 后的 OSS url） */
  primarySrc?: string;
  /** 加载失败后的兜底图片（原图） */
  fallbackSrc?: string;
};

/**
 * 图片源回退策略组件
 * @param primarySrc 优先加载的图片（如 resize 后的 OSS url）
 * @param fallbackSrc 加载失败后的兜底图片（原图）
 * @returns 
 */
export const FallbackImage: React.FC<FallbackImageProps> = ({
  primarySrc,
  fallbackSrc,
  onError,
  ...rest
}) => {
  const fallbackRef = useRef(false);

  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    if (!fallbackRef.current && fallbackSrc) {
      fallbackRef.current = true;
      e.currentTarget.src = fallbackSrc;
    }
    onError?.(e);
  };

  return (
    <Image
      {...rest}
      src={primarySrc || fallbackSrc || ''}
      onError={handleError}
    />
  );
};
